// utils/formatDate.js
export function formatDate(timestamp) {
  if (!timestamp) return "";

  // Convert Firestore Timestamp to JS Date
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

  const day = String(date.getDate()).padStart(2, "0");

  // Array of month short names
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = months[date.getMonth()]; // getMonth() is 0-indexed

  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}


export function formatDate2(timestamp) {
  if (!timestamp) return "";

  // Convert Firestore Timestamp to JS Date
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);

  const day = String(date.getDate()).padStart(2, "0");

  // Array of month short names
  const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = months[date.getMonth()]; // getMonth() is 0-indexed

  const year = date.getFullYear();

  // return with hour and minute
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  // am or pm
  const ampm = hours >= 12 ? "PM" : "AM";

  return `${day}-${month}-${year} ${hours}:${minutes}:${seconds} ${ampm}`;
}
